/** @format */

import axios from "axios";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_Schedule;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const API = {
  listar: async (id, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINT}${id}/Student`, {
        headers: headers,
      });
      if (result.data.detail == undefined) {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.dayArray.length == 0) {
        getAlert(result.data.message, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(Constantes().SeccionExpirada, "./Login");
    }
  },
};

export default API;
